import { render, staticRenderFns } from "./LandingPaymentPage.vue?vue&type=template&id=bc9c8820&scoped=true"
import script from "./LandingPaymentPage.vue?vue&type=script&lang=ts"
export * from "./LandingPaymentPage.vue?vue&type=script&lang=ts"
import style0 from "./LandingPaymentPage.vue?vue&type=style&index=0&id=bc9c8820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9c8820",
  null
  
)

export default component.exports